import { APP_INITIALIZER, ErrorHandler, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { IonicModule } from '@ionic/angular';
import { NgModelDirective } from './directives/ui/input.directive';
import { MouseDirective } from './directives/ui/mouse.directive';
import { EVENT_MANAGER_PLUGINS } from '@angular/platform-browser';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { ClickLoggerService } from './directives/ui/click.service';
import { NavigationLoggerService } from './directives/navigation.service';
import { ErrorLoggerService } from './directives/error.service';
import { NetworkLoggerService } from './directives/network.service';
import { LeaveLoggerService } from './directives/leave.service';

@NgModule({
  imports: [
    CommonModule,
    IonicModule,
  ],
  declarations: [NgModelDirective, MouseDirective],
  exports: [NgModelDirective, MouseDirective],
  providers: [
      NavigationLoggerService,
      LeaveLoggerService,
    {
      provide: APP_INITIALIZER,
      multi: true,
      useFactory: (navService: NavigationLoggerService, leaveService: LeaveLoggerService) => () => {},
      deps: [NavigationLoggerService, LeaveLoggerService]
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: NetworkLoggerService,
      multi: true
    },
  ]
})
export class LoggingModule {}
